import { ShieldCheckIcon } from "@heroicons/react/24/solid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function VerifiedBadge() {
  return /*#__PURE__*/_jsxs("span", {
    className: "bg-teal-100 flex gap-2 rounded-full px-2 text-xs items-center font-modern-era-medium text-teal-500",
    children: [/*#__PURE__*/_jsx(ShieldCheckIcon, {
      className: "w-4 h-4"
    }), "Verified"]
  });
}